// Vendor Libraries
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {at, concat, filter, get, isEmpty, map, orderBy, startCase} from 'lodash';
import {isURL} from 'validator';

// Components
import Loading from '../core/loading';
import Thumbnail from '../core/thumbnail';

export default class MediaItemThumbnails extends Component {
    renderThumbnails() {
        const {className, error, fetching, searchValues} = this.props;
        let mediaItemThumbnails = [];
        let moviesProgramsThumbnails = [];
        let moviesProgramsEpisodeThumbnails = [];

        if (!error && !isEmpty(searchValues)) {
            mediaItemThumbnails = map(
                filter(at(searchValues, ['masterThumbnailImage', 'franchiseThumbnailImage']), (image) =>
                    isURL(get(image, 'finalResourceName') !== null ? get(image, 'finalResourceName', '') : '')
                ),
                ({category, finalResourceName, height, imageId, width}) => (
                    <Thumbnail
                        className="mediaitem-detail--thumbnail"
                        height={height}
                        key={imageId}
                        label={category === 'thumbnail' ? 'Master Thumbnail' : 'Franchise Thumbnail'}
                        loading={fetching}
                        src={finalResourceName}
                        title="Image from provider"
                        width={width}
                    />
                )
            );

            moviesProgramsThumbnails = map(
                orderBy(
                    filter(
                        concat(
                            get(searchValues, 'amsFranchise.images', []),
                            get(searchValues, 'amsFranchise.seasonImages', [])
                        ),
                        (image) => isURL(get(image, 'url') !== null ? get(image, 'url', '') : '')
                    ),
                    'category'
                ),
                ({amsGalleryId, category, imageHeight, imageWidth, url}) => (
                    <Thumbnail
                        className="mediaitem-detail--thumbnail"
                        height={imageHeight}
                        key={amsGalleryId}
                        label={startCase(category)}
                        loading={fetching}
                        src={url}
                        width={imageWidth}
                    />
                )
            );

            moviesProgramsEpisodeThumbnails = map(
                orderBy(
                    filter(
                        filter(
                            concat(
                                get(searchValues, 'amsEpisode.images', []),
                                get(searchValues, 'amsEpisode.seasonImages', [])
                            ),
                            (image) => isURL(get(image, 'url') !== null ? get(image, 'url', '') : '')
                        ),
                        ({category}) => category !== 'Franchise' && category !== 'TitleArt'
                    ),
                    'category'
                ),
                ({amsGalleryId, category, imageHeight, imageWidth, url}) => (
                    <Thumbnail
                        className="mediaitem-detail--thumbnail"
                        height={imageHeight}
                        key={amsGalleryId}
                        label={startCase(category)}
                        loading={fetching}
                        src={url}
                        width={imageWidth}
                    />
                )
            );
        }

        return mediaItemThumbnails.length ||
            moviesProgramsThumbnails.length ||
            moviesProgramsEpisodeThumbnails.length ? (
            <div className={classnames('mediaitem-detail--thumbnail-group', className)}>
                {mediaItemThumbnails}
                {moviesProgramsThumbnails}
                {moviesProgramsEpisodeThumbnails}
            </div>
        ) : null;
    }

    render() {
        const {fetching} = this.props;

        return (
            <div className="mediaitem-thumbnails">
                <Loading loading={fetching} />
                {this.renderThumbnails()}
            </div>
        );
    }
}

MediaItemThumbnails.propTypes = {
    className: PropTypes.string,
    error: PropTypes.string,
    fetching: PropTypes.bool,
    searchValues: PropTypes.object,
};
